<template>
  <el-card class="h-full">
    <div class="flex mb-10px mr-10px">
      <el-input
        size="small"
        class="mr-10px !w-50"
        placeholder="违章描述"
        v-model="searchData.Title"
        clearable
      ></el-input>
      <el-select
        size="small"
        class="mr-10px !w-50"
        placeholder="被考核人"
        filterable
        v-model="searchData.Type"
        @change="handleSearch"
        clearable
      >
        <el-option v-for="(item, index) in []" :key="index" label="在厂" :value="0"></el-option>
      </el-select>
      <el-button size="small" type="primary" @click="handleSearch">搜索</el-button>
    </div>
    <el-table
      :data="dataList"
      border
      class="w-full"
      :height="tableHeight"
      stripe
      v-loading="tableLoading"
      @selection-change="handleSelectionChange"
    >
      <el-table-column label="序号" type="index" width="50" align="center"></el-table-column>
      <el-table-column
        label="违章描述"
        align="center"
        prop="title"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        label="违章考核部门/单位"
        align="center"
        prop="title"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        label="被考核人"
        align="center"
        prop="title"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        label="违章行为"
        align="center"
        prop="title"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        label="考核扣分数"
        align="center"
        prop="title"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column label="考核时间" align="center" prop="readStatus" width="100">
        <!-- <template slot-scope="scope">
          <span>{{ dayjs(currentMsgDetail.sendTime).format('YYYY-MM-DD HH:mm:ss') }}</span>
        </template> -->
      </el-table-column>
      <el-table-column label="操作" align="center" width="180">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleDetail(scope.row)" v-if="$hasAccess('detail')"
            >查看</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      @size-change="tableSizeChange"
      @current-change="tableCurrentChange"
      :current-page.sync="pageConfig.SkipCount"
      :page-size.sync="pageConfig.MaxResultCount"
      layout="total, sizes, prev, pager, next, jumper"
      :page-sizes="[15, 30, 45, 60, 75, 90]"
      :total="totalCount"
      class="float-right mt-10px ml-10px"
    ></el-pagination>

    <el-dialog
      :close-on-click-modal="false"
      title="查看"
      :visible.sync="msgDialog"
      width="800px"
      v-dialogDrag
    >
      <el-form ref="formAdd" label-width="150px" :model="currentMsgDetail">
        <el-form-item label="标题：">
          <div>{{ currentMsgDetail.title }}</div>
        </el-form-item>
        <el-form-item label="消息内容：">
          <div :title="currentMsgDetail.content" class="w-600px truncate">
            {{ currentMsgDetail.content }}
          </div>
        </el-form-item>
        <el-form-item label="消息类型：">
          <div>{{ currentMsgDetail.type }}</div>
        </el-form-item>
        <el-form-item label="推送时间：">
          <div class="w-600px truncate">
            {{
              currentMsgDetail.sendTime &&
                dayjs(currentMsgDetail.sendTime).format('YYYY-MM-DD HH:mm:ss')
            }}
          </div>
        </el-form-item>
        <el-form-item label="发送人：">
          <div>{{ currentMsgDetail.sendName }}</div>
        </el-form-item>
        <el-form-item label="接收人：">
          <div>{{ currentMsgDetail.receiveName }}</div>
        </el-form-item>
      </el-form>
      <div class="flex justify-center">
        <el-button size="small" @click="msgDialog = false">取消</el-button>
      </div>
    </el-dialog>
  </el-card>
</template>

<script>
import dayjs from 'dayjs'
import { MessageApi } from '@wiz-api/message-management'

const messageApi = new MessageApi()

export default {
  name: 'AccidentEventInfo',
  data() {
    return {
      row: null,
      multipleSelect: [],
      tableLoading: false,
      dataList: [],
      totalCount: 0,
      searchData: {
        Type: '',
        ReadStatus: '',
        Title: '',
      },
      pageConfig: {
        SkipCount: 1,
        MaxResultCount: 15,
      },
      msgDialog: false,
      currentMsgDetail: {
        title: '',
        content: '',
        type: '',
        sendTime: '',
        sendName: '',
        receiveName: '',
        creationTime: '',
      },
      optionList: [
        {
          label: '已读',
          value: 1,
        },
        {
          label: '未读',
          value: 0,
        },
      ],
    }
  },
  created() {
    // const userInfo = Wiz.AuthHooks.GetUserInfo()
    // const { sub } = userInfo?.profile
    // this.searchData.userId = sub
    this.getMsgList()
  },
  computed: {
    tableHeight() {
      return 'calc(100% - 130px)'
    },
  },
  methods: {
    // 批量选中处理
    handleSelectionChange(val) {
      this.multipleSelect = val
    },
    // 详情
    async handleDetail(row) {
      this.row = row
      const [err, res] = await messageApi.getNoticeDetail(row.id)
      if (!err) {
        this.msgDialog = true
        this.$set(this, 'currentMsgDetail', res)
        this.msgDialog = true
      }
    },
    // 搜索
    handleSearch() {
      this.pageConfig.SkipCount = 1
      this.getMsgList()
    },
    // 重置
    handleReset() {
      this.searchData = {
        Type: '',
        ReadStatus: '',
        Title: '',
      }
    },
    // 页码改变
    tableSizeChange(SkipCount) {
      this.pageConfig.SkipCount = SkipCount
      this.getMsgList()
    },
    // 页数改变
    tableCurrentChange(MaxResultCount) {
      this.pageConfig.MaxResultCount = MaxResultCount
      this.getMsgList()
    },
    // 获取消息列表
    async getMsgList() {
      // this.tableLoading = true
      // this.multipleSelect = []
      // const data = {
      //   MaxResultCount: this.pageConfig.MaxResultCount, // 每页多少条
      //   SkipCount: (this.pageConfig.SkipCount - 1) * this.pageConfig.MaxResultCount, // 跳过多少条
      //   ...this.searchData,
      // }
      // const [err, res] = await messageApi.getPageList(data)
      // if (!err) {
      //   this.dataList = res.items
      //   this.totalCount = res.totalCount
      //   this.tableLoading = false
      // }
      this.dataList = [
        {
          title: '测试数据',
        },
      ]
    },
  },
}
</script>

<style scoped lang="scss">
::v-deep .el-card__body {
  height: 100%;
}
</style>
